import { Card, CardContent } from "../../components/ui/card";
import { Badge } from "../../components/ui/badge";
import { Target, UserCheck, Activity, AlertTriangle } from "lucide-react";

function getReadinessBadgeStyle(score) {
  if (score >= 80) return 'bg-[#14B8A6]/10 text-[#14B8A6]';
  if (score >= 60) return 'bg-[#F59E0B]/10 text-[#F59E0B]';
  return 'bg-red-50 text-red-500';
}

function getReadinessBadgeLabel(score) {
  if (score >= 80) return 'Strong';
  if (score >= 60) return 'Moderate';
  return 'Needs Work';
}

export function KpiCards({ kpi, totalReps, getScoreColor }) {
  return (
    <div className="grid grid-cols-2 lg:grid-cols-4 gap-4 mb-8" data-testid="kpi-section">
      <Card className="premium-card fade-up" data-testid="kpi-readiness">
        <CardContent className="p-5">
          <div className="flex items-start justify-between mb-3">
            <div className="w-10 h-10 bg-[#0B1F3B] rounded-xl flex items-center justify-center">
              <Target className="w-5 h-5 text-white" />
            </div>
            <Badge className={`text-xs ${getReadinessBadgeStyle(kpi.team_readiness)}`}>
              {getReadinessBadgeLabel(kpi.team_readiness)}
            </Badge>
          </div>
          <p className={`text-3xl font-bold ${getScoreColor(kpi.team_readiness)}`}>{kpi.team_readiness || 0}%</p>
          <p className="text-sm text-slate-500 mt-1">Team Readiness Score</p>
        </CardContent>
      </Card>

      <Card className="premium-card fade-up fade-up-delay-1" data-testid="kpi-field-ready">
        <CardContent className="p-5">
          <div className="flex items-start justify-between mb-3">
            <div className="w-10 h-10 bg-[#14B8A6]/10 rounded-xl flex items-center justify-center">
              <UserCheck className="w-5 h-5 text-[#14B8A6]" />
            </div>
          </div>
          <p className="text-3xl font-bold text-[#0B1F3B]">
            {kpi.field_ready_count || 0}<span className="text-lg text-slate-400 font-normal">/{totalReps}</span>
          </p>
          <p className="text-sm text-slate-500 mt-1">Field-Ready Reps</p>
        </CardContent>
      </Card>

      <Card className="premium-card fade-up fade-up-delay-2" data-testid="kpi-sessions">
        <CardContent className="p-5">
          <div className="flex items-start justify-between mb-3">
            <div className="w-10 h-10 bg-[#2563EB]/10 rounded-xl flex items-center justify-center">
              <Activity className="w-5 h-5 text-[#2563EB]" />
            </div>
          </div>
          <p className="text-3xl font-bold text-[#0B1F3B]">{kpi.total_sessions || 0}</p>
          <p className="text-sm text-slate-500 mt-1">Practice Sessions</p>
        </CardContent>
      </Card>

      <Card className="premium-card fade-up fade-up-delay-3" data-testid="kpi-coaching">
        <CardContent className="p-5">
          <div className="flex items-start justify-between mb-3">
            <div className="w-10 h-10 bg-[#F59E0B]/10 rounded-xl flex items-center justify-center">
              <AlertTriangle className="w-5 h-5 text-[#F59E0B]" />
            </div>
          </div>
          <p className="text-lg font-bold text-[#0B1F3B] truncate">{kpi.top_coaching_priority || "\u2014"}</p>
          <p className="text-sm text-slate-500 mt-1">Top Coaching Priority</p>
        </CardContent>
      </Card>
    </div>
  );
}
